const main = () => {
    if(!document.querySelector('#page-voice-index')) return;

    $('.body').each((idx, obj) => {
        let h1 = $(obj).find('.content').height()
        let h2 = $(obj).find('.content .wrap').height()
        if(h1 == h2){
            $(obj).find('.grad-trigger').prop('checked', true)
        }
    })

}
export default main;
